// extracted by mini-css-extract-plugin
export default {"tooltip":"Mp-z","sharingV2":"Np-z","sharingIconsV2":"Op-z","links":"Pp-z","link":"Qp-z","facebookV2":"Rp-z","twitterV2":"Sp-z","pinterestV2":"Tp-z"};